import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Pipe({
  name: 'contentCrossCountrySkiing'
})
export class CrossCountrySkiingPipe implements PipeTransform {

  constructor() {
  }

  transform(entry: Models.ContentEntry): Models.CrossCountryAreaEntry {

    if (!entry || !entry.detail || !entry.detail.slopes) {
      return null;
    }

    const crossCountryArea = new Models.CrossCountryAreaEntry();

    const crossCountrySlopes: Models.CrossCountrySlopeEntry[] = [];

    for (const rawCrossCountrySlope of entry.detail.slopes) {

      const crossCountrySlope = new Models.CrossCountrySlopeEntry();
      const crossCountrySlopeContent = {
        id: rawCrossCountrySlope.id,
        title: rawCrossCountrySlope.title
      };

      if (rawCrossCountrySlope.classic) {
        const classicSlopePart = new Models.CrossCountrySlopePartEntry();
        classicSlopePart.populateFromJSON({
          difficulty: rawCrossCountrySlope.classic.difficulty,
          length: rawCrossCountrySlope.classic.length,
          openLength: rawCrossCountrySlope.classic.open_length,
          statusId: rawCrossCountrySlope.classic.status,
          additionalStatus: rawCrossCountrySlope.classic.additionalStatus
        });

        crossCountrySlope.classic = classicSlopePart;
      }

      if (rawCrossCountrySlope.skating) {
        const skatingSlopePart = new Models.CrossCountrySlopePartEntry();
        skatingSlopePart.populateFromJSON({
          difficulty: rawCrossCountrySlope.skating.difficulty,
          length: rawCrossCountrySlope.skating.length,
          openLength: rawCrossCountrySlope.skating.open_length,
          statusId: rawCrossCountrySlope.skating.status,
          additionalStatus: rawCrossCountrySlope.skating.additionalStatus
        });

        crossCountrySlope.skating = skatingSlopePart;
      }

      crossCountrySlope.populateFromJSON(crossCountrySlopeContent);
      crossCountrySlopes.push(crossCountrySlope);
    }

    if (crossCountrySlopes.length === 0) {
      return null;
    }

    crossCountryArea.populateFromJSON({
      sourceId: entry._id,
      slopes: crossCountrySlopes
    });

    return crossCountryArea;
  }

}
